import type { JSX } from 'react';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { SortableTableHeaders } from '@/shared/components/SortableTableHeaders';
import type { SortState } from '@/shared/types/table-filters.types';
import { SuperAdminRow } from './SuperAdminRow';
import type { SuperAdmin } from '../types/super-admin.types';

interface SuperAdminTableProps {
  superAdmins: SuperAdmin[];
  sort: SortState | null;
  onToggleSort: (key: string) => void;
  currentUserId?: string | undefined;
  onEdit: (superAdmin: SuperAdmin) => void;
}

/** Role has no header of its own to sort: every row on this screen is a SUPER_ADMIN. */
const LEADING_HEADERS = [{ key: 'name', label: 'User', className: 'w-[300px]' }];

const TRAILING_HEADERS = [
  { key: 'isActive', label: 'Status' },
  { key: 'createdAt', label: 'Created' },
];

export function SuperAdminTable({
  superAdmins,
  sort,
  onToggleSort,
  currentUserId,
  onEdit,
}: SuperAdminTableProps): JSX.Element {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <SortableTableHeaders
              headers={LEADING_HEADERS}
              sort={sort}
              onToggleSort={onToggleSort}
            />
            <TableHead>Role</TableHead>
            <SortableTableHeaders
              headers={TRAILING_HEADERS}
              sort={sort}
              onToggleSort={onToggleSort}
            />
            <TableHead className="w-[70px]" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {superAdmins.map((sa) => (
            <SuperAdminRow
              key={sa.id}
              superAdmin={sa}
              isCurrentUser={sa.id === currentUserId}
              onEdit={onEdit}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
